var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { attrs: { toggleable: "md", type: "primary", variant: "light" } },
    [
      _c("b-nav-text", { attrs: { type: "light", variant: "light" } }, [
        _vm._v(
          "\n    Online Training Booking  [V" + _vm._s(_vm.version) + "]\n  "
        )
      ]),
      _vm.isLoggedIn
        ? _c(
            "b-navbar-nav",
            { attrs: { pills: "" } },
            [
              _vm.$store.state.authUser.flag !== "tv"
                ? _c(
                    "b-button",
                    {
                      staticClass: "change-page-menu",
                      attrs: {
                        variant: "outline-dark",
                        size: "sm",
                        to: _vm.mainPath.mainPage
                      }
                    },
                    [_vm._v("\n      Calendar View\n    ")]
                  )
                : _vm._e(),
              _vm.$store.state.authUser.flag !== "tv"
                ? _c(
                    "b-button",
                    {
                      staticClass: "change-page-menu",
                      attrs: {
                        variant: "outline-dark",
                        size: "sm",
                        to: _vm.mainPath.dashboard
                      }
                    },
                    [_vm._v("\n      Dash Board\n    ")]
                  )
                : _vm._e(),
              _vm.$store.state.authUser.flag !== "tv"
                ? _c(
                    "b-button",
                    {
                      staticClass: "change-page-menu",
                      attrs: {
                        variant: "outline-dark",
                        size: "sm",
                        disabled: "",
                        hidden: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n      Combo-Book [testing, pls dont use]\n      "
                      ),
                      _c("a", { attrs: { href: "" } })
                    ]
                  )
                : _vm._e(),
              _vm.$store.state.authUser.flag === "tv"
                ? _c(
                    "b-button",
                    {
                      staticClass: "change-page-menu",
                      attrs: {
                        variant: "outline-dark",
                        size: "sm",
                        to: _vm.mainPath.tvCal
                      }
                    },
                    [_vm._v("\n      TV Calendar\n    ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.isLoggedIn
        ? _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item-dropdown",
                { attrs: { right: "" } },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("em", [_vm._v(_vm._s(_vm.displayLoginInfo))])
                  ]),
                  _c("b-dropdown-item", { on: { click: _vm.userLogout } }, [
                    _vm._v("Signout")
                  ])
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd0cb03a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd0cb03a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/DefaultHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cd0cb03a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/DefaultHeader.vue
// module chunks = 9 11